import React, { Component } from "react"
import { withStyles } from "@material-ui/core"

import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"
import * as constants from "../constants"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

const optionStep = [
      { value: "0", label: "حق بیمه پایه" },
      { value: "1", label: "سرمایه" },
      { value: "2", label: "مبلغ ثابت" },
]

class BodyCarCovarage extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  bodycarCovarageState: this.props.bodycarCovarage,
                  selectedBodycarCovarage: {
                        value: this.props.bodycarCovarage.bodycar_price_covarage_bodycoverage_id,
                        label: this.props.bodycarCovarage.bodycar_coverage_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionBodycarCovarage: [],
            }
      }
      componentDidMount() {
            this.getoptionBodycarCovarage()
      }

      getoptionBodycarCovarage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].bodycar_coverage_id, label: arr.data[k].bodycar_coverage_name })
                              }
                              self.setState({ optionBodycarCovarage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedBodycarCovarage) => {
            var temparray = this.state.bodycarCovarageState
            temparray.bodycar_price_covarage_bodycoverage_id = selectedBodycarCovarage.value
            this.setState({ selectedBodycarCovarage: selectedBodycarCovarage, bodycarCovarageState: temparray })
      }

      handleChangeConditionsPercent = (event) => {
            var temparray = this.state.bodycarCovarageState
            temparray.bodycar_price_covarage_percent = event
            this.setState({ bodycarCovarageState: temparray })
      }

      handleCalculate = (event) => {
            var temparray = this.state.bodycarCovarageState
            temparray.bodycar_price_covarage_percent = event
            this.setState({ bodycarCovarageState: temparray })
      }

      handleCalculate = (selectedCalculate) => {
            var temparray = this.state.bodycarCovarageState
            temparray.bodycar_price_covarage_calmode_id = selectedCalculate.value
            this.setState({ bodycarCovarageState: temparray })
      }
      modifyNewInstalmentCondition = () => {
            const { bodycarCovarageState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_coverage")
            fd.append("bodycar_price_covarage_id", bodycarCovarageState.bodycar_price_covarage_id)
            fd.append("bodycar_price_covarage_percent", bodycarCovarageState.bodycar_price_covarage_percent)
            fd.append("bodycar_price_covarage_calmode_id", bodycarCovarageState.bodycar_price_covarage_calmode_id)

            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { bodycarCovarageState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_coverage")
            fd.append("bodycar_price_covarage_id", bodycarCovarageState.bodycar_price_covarage_id)

            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { optionBodycarCovarage, snackMode, snackstr, showSnack, visible, selectedBodycarCovarage, bodycarCovarageState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={4}>
                                    <div>
                                          <label className="on"> پوشش بدنه </label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"پوشش بدنه "}
                                                value={selectedBodycarCovarage}
                                                onChange={this.handleInstalmentMode}
                                                options={optionBodycarCovarage}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder="درصد پوشش مالی"
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={bodycarCovarageState.bodycar_price_covarage_percent}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div>
                                          <label className="on">فیلد مورد محاسبه</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"فیلد مورد محاسبه"}
                                                value={optionStep[bodycarCovarageState.bodycar_price_covarage_calmode_id]}
                                                onChange={this.handleCalculate}
                                                options={optionStep}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={2}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(BodyCarCovarage)
